<template> 
    <div>
        <v-card>            
            <v-card-text v-if="$store.state.qlikAuthenticated">
                <iframe style="position:absolute; top:0; left:0; bottom:0; right:0; width:100%; height:90vh; border:none; margin:0; padding:0; overflow:hidden" :src="$store.state.deepLink"></iframe>                
            </v-card-text>            
        </v-card>
    </div>    
</template>

<script>

export default {
    mounted: function()
    {
        if (!window.location.host.startsWith("localhost"))
        {
            if (this.$store.state.qlikToken != null)
            {
                const jwt = this.$store.state.qlikToken;
                const url = this.$store.state.qlikUrl;
                const xmlHttpRequest = new XMLHttpRequest();
                const self = this;
                xmlHttpRequest.open("GET", url, true);
                xmlHttpRequest.setRequestHeader('Authorization', 'Bearer ' + jwt);
                xmlHttpRequest.withCredentials = true;
                xmlHttpRequest.onreadystatechange = function ()
                {
                    if(xmlHttpRequest.readyState === XMLHttpRequest.DONE)
                    {
                        const status = xmlHttpRequest.status;
                        if (status === 200)
                            self.$store.state.qlikAuthenticated = true;                    
                    }
                }
                xmlHttpRequest.send();
            }
        }
    }
};
</script>